import Logger from './Logger';
import mixpanel from 'mixpanel-browser';
import Auth from './Auth';
import Config from '../Config';

const mixpanelEventsEnum = {
  LOGIN: {
    STARTED_LOGIN: 'Login | Started Login',
    SUCCESSFUL_LOGIN: 'Login | Successful Login',
    CREDENTIALS_FAILED: 'Login | Failed Login due to credentials',
  },
  PAGES: {
    ACCESS_CARE_GUIDE: 'Pages | Access Care Guide',
    ACCESS_PAGE: 'Pages | Access Page',
    ACCESS_PAGE_ADMINISTRATOR: 'Pages | Access Page Administrator',
  },
  RESOURCE: {
    OPEN_PREVIEW: 'Resource | Open Preview',
    TOGGLE_FAVORITE: 'Resource | Toggle Favorite',
    TOGGLE_PINNED: 'Resource | Toggle Pinned',
    TOGGLE_DISABLE: 'Resource | Toggle Disable',
    OPEN_LINK: 'Resource | Open Link',
    CREATE: 'Resource | Create',
    EDIT: 'Resource | Edit',
    DELETE: 'Resource | Delete',
    DELETES: 'Resource | Deletes',
    EXPORT_CSV: 'Resource | Export Csv',
    EXPORT_PDF: 'Resource | Export Pdf',
    EXPORT_RESOURCES_PDF: 'Resource | Export Pdf Resources',
    OPEN_NOTES: 'Resource | Open Notes',
    CREATE_NOTE: 'Resource | Create Note',
    DELETE_NOTE: 'Resource | Delete Note',
    EDIT_NOTE: 'Resource | Edit Note',
    EXPORT_NOTES_CSV: 'Resource | Export Csv Notes',
  },
  CALENDAR: {
    CREATE_EVENT: 'Calendar | Create Event',
    EDIT_EVENT: 'Calendar | Edit Event',
    DELETE_EVENT: 'Calendar | Delete Event',
    VIEW_EVENT: 'Calendar | View Event',
    RESPOND: 'Calendar | Respond Event',
  },
  CARE_GUIDE: {
    EXPORT_PDF: 'Care Guide | Export PDF',
    EXPORT_PDF_SEGMENT: 'Care Guide | Export PDF Segment',
  },
  JOURNAL: {
    CREATE_POST: 'Journal | Create Post',
    EDIT_POST: 'Journal | Edit Post',
    CREATE_REPLY_POST: 'Journal | Create Reply Post',
    EDIT_REPLY_POST: 'Journal | Edit Reply Post',
    DELETE_REPLY_POST: 'Journal | Delete Reply Post',
    EXPORT_PDF: 'Journal | Export PDF',
    CREATE_REACTION_EMOJI_POST: 'Journal | Create Reaction Emoji Post',
    DELETE_REACTION_EMOJI_POST: 'Journal | Delete Reaction Emoji Post',
  },
  DASHBOARD: {
    RESOURCE_OPEN_PREVIEW: 'Dashboard | Resource Open Preview',
    RESOURCE_OPEN_LINK: 'Dashboard | Resource Open Link',
    RESOURCE_TOGGLE_FAVORITE: 'Dashboard | Resource Toggle Favorite',
    DAYLY_LOGS_CHANGE_DATE: 'Dashboard | Daily Logs Change Date',
    DAYLY_LOG_DOWNLOAD_PDF: 'Dashboard | Daily Log Download PDF',
    DAYLY_LOG_COLLAPSE_ENTRY: 'Dashboard | Daily Log Collapse Entry',
    RECOMMENDED_UTILITY_OPEN_LINK: 'Dashboard | Recommended Utility Open Link',
    RECOMMENDED_UTILITY_DOWNLOAD_DOCUMENT:
      'Dashboard | Recommended Utility Download Document',
    CARE_GUIDE_INVITATION_RESEND: 'Dashboard | Care Guide Invitation Resend',
    CARE_GUIDE_INVITATION_RESPOND: 'Dashboard | Care Guide Invitation Respond',
    CARE_GUIDE_INVITATION_INVITE: 'Dashboard | Care Guide Invitation Invite',
    CARE_GUIDE_INVITATION_SEND: 'Dashboard | Care Guide Invitation Send',
    CARE_GUIDE_HELPER_OPEN_LINK: 'Dashboard | Care Guide Helper Open Link',
    CARE_GUIDE_HELPER_MESSAGE: 'Dashboard | Care Guide Helper Message',
    CALENDAR_EVENT_RESPOND: 'Dashboard | Calendar Event Respond',
    CALENDAR_EVENT_VIEW: 'Dashboard | Calendar Event View',
  },
  ACTIONS_PARTNER: {
    PARTNERSHIP_ACCOUNT_UPLOAD_LOGO:
      'Actions Partner | Partnership Account Upload Logo',
    PARTNERSHIP_ACCOUNT_REMOVE_LOGO:
      'Actions Partner | Partnership Account Remove Logo',
    PARTNERSHIP_ACCOUNT_ACTIVE_TAB_PARTNER_ADMIN:
      'Actions Partner | Partnership Account Active Tab Partner Admin',
    PARTNERSHIP_ACCOUNT_DESACTIVE_TAB_PARTNER_ADMIN:
      'Actions Partner | Partnership Account Desactive Tab Partner Admin',
    PARTNERSHIP_ACCOUNT_SUBMIT_TABS_PARTNER_ADMIN:
      'Actions Partner | Partnership Account Submit Tabs Partner Admin',
    PARTNERSHIP_ACCOUNT_ACTIVE_TAB_MEMBERS:
      'Actions Partner | Partnership Account Active Tab Members',
    PARTNERSHIP_ACCOUNT_DESACTIVE_TAB_MEMBERS:
      'Actions Partner | Partnership Account Desactive Tab Members',
    PARTNERSHIP_ACCOUNT_SUBMIT_TABS_MEMBERS:
      'Actions Partner | Partnership Account Submit Tabs Members',
    PARTNERSHIP_ACCOUNT_SUBMIT_FORM:
      'Actions Partner | Partnership Account Submit Form',
    PARTNERSHIP_ACCOUNT_ACTIVE_TAB_ACCOUNT:
      'Actions Partner | Partnership Account Active Tab Account',
    PARTNERSHIP_ACCOUNT_DESACTIVE_TAB_ACCOUNT:
      'Actions Partner | Partnership Account Desactive Tab Account',
    PARTNERSHIP_ACCOUNT_SUBMIT_ACCOUNT:
      'Actions Partner | Partnership Account Submit Account',
    REGISTRATION_CODES_SEARCH: 'Actions Partner | Registration Codes Search',
    REGISTRATION_CODES_RESET: 'Actions Partner | Registration Codes Reset',
    REGISTRATION_CODES_EDIT_SUBMIT:
      'Actions Partner | Registration Codes Edit Submit',
    REGISTRATION_CODES_EDIT_SCREEN:
      'Actions Partner | Registration Codes Edit Screen',
    JOURNAL_PARTNER_TAGS_ADMIN_SEARCH:
      'Actions Partner | Journal Partner Tags Admin Search',
    JOURNAL_PARTNER_TAGS_ADMIN_RESET:
      'Actions Partner | Journal Partner Tags Admin Reset',
    JOURNAL_PARTNER_TAGS_ADMIN_ADD_SUBMIT:
      'Actions Partner | Journal Partner Tags Admin Add Submit',
    JOURNAL_PARTNER_TAGS_ADMIN_EDIT_SUBMIT:
      'Actions Partner | Journal Partner Tags Admin Edit Submit',
    JOURNAL_PARTNER_TAGS_ADMIN_EDIT_SCREEN:
      'Actions Partner | Journal Partner Tags Admin Edit Screen',
    JOURNAL_PARTNER_TAGS_ADMIN_ADD_SCREEN:
      'Actions Partner | Journal Partner Tags Admin Add Screen',
    JOURNAL_PARTNER_TAGS_ADMIN_DELETE:
      'Actions Partner | Journal Partner Tags Admin Delete',

    CARE_GUIDE_PARTNER_TAGS_ADMIN_SEARCH:
      'Actions Partner | Care Guide Partner Tags Admin Search',
    CARE_GUIDE_PARTNER_TAGS_ADMIN_RESET:
      'Actions Partner | Care Guide Partner Tags Admin Reset',
    CARE_GUIDE_PARTNER_TAGS_ADMIN_ADD_SUBMIT:
      'Actions Partner | Care Guide Partner Tags Admin Add Submit',
    CARE_GUIDE_PARTNER_TAGS_ADMIN_EDIT_SUBMIT:
      'Actions Partner | Care Guide Partner Tags Admin Edit Submit',
    CARE_GUIDE_PARTNER_TAGS_ADMIN_EDIT_SCREEN:
      'Actions Partner | Care Guide Partner Tags Admin Edit Screen',
    CARE_GUIDE_PARTNER_TAGS_ADMIN_ADD_SCREEN:
      'Actions Partner | Care Guide Partner Tags Admin Add Screen',
    CARE_GUIDE_PARTNER_TAGS_ADMIN_DELETE:
      'Actions Partner | Care Guide Partner Tags Admin Delete',
    USER_PROFILES_PARTNERSHIPS_ADMIN_SEARCH:
      'Actions Partner | User Profiles Partnerships Admin Search',
    USER_PROFILES_PARTNERSHIPS_ADMIN_RESET:
      'Actions Partner | User Profiles Partnerships Admin Reset',

    CALENDAR_EVENTS_ADMIN_SEARCH:
      'Actions Partner | Calendar Events Admin Search',
    CALENDAR_EVENTS_ADMIN_RESET:
      'Actions Partner | Calendar Events Admin Reset',
    CALENDAR_EVENTS_ADMIN_ADD_SUBMIT:
      'Actions Partner | Calendar Events Admin Add Submit',
    CALENDAR_EVENTS_ADMIN_EDIT_SUBMIT:
      'Actions Partner | Calendar Events Admin Edit Submit',
    CALENDAR_EVENTS_ADMIN_EDIT_SCREEN:
      'Actions Partner | Calendar Events Admin Edit Screen',
    CALENDAR_EVENTS_ADMIN_ADD_SCREEN:
      'Actions Partner | Calendar Events Admin Add Screen',
    CALENDAR_EVENTS_ADMIN_DELETE:
      'Actions Partner | Calendar Events Admin Delete',
    CALENDAR_EVENTS_ADMIN_VIEW_DETAIL:
      'Actions Partner | Calendar Events Admin View Detail',
    CALENDAR_EVENTS_ADMIN_EDIT_PARTICIPANT_SUBMIT:
      'Actions Partner | Calendar Events Admin Edit Participant Submit',
    CALENDAR_EVENTS_ADMIN_ADD_PARTICIPANT_SUBMIT:
      'Actions Partner | Calendar Events Admin Add Participant Submit',
    CALENDAR_EVENTS_ADMIN_SHOW_PARTICIPANT_FORM_MODAL:
      'Actions Partner | Calendar Events Admin Show Participant Form Modal',
    CALENDAR_EVENTS_ADMIN_HIDE_PARTICIPANT_FORM_MODAL:
      'Actions Partner | Calendar Events Admin Hide Participant Form Modal',
    CALENDAR_EVENTS_ADMIN_DELETE_PARTICIPANT:
      'Actions Partner | Calendar Events Admin Delete Participant',
    CALENDAR_EVENTS_ADMIN_ADD_PARTICIPANT:
      'Actions Partner | Calendar Events Admin Add Participant',

    RESOURCES_ADMIN_SEARCH: 'Actions Partner | Resources Admin Search',
    RESOURCES_ADMIN_VIEW_CHANGE:
      'Actions Partner | Resources Admin View Change',
    RESOURCES_ADMIN_OPEN_PREVIEW:
      'Actions Partner | Resources Admin Open Preview',
    RESOURCES_ADMIN_HIDE_PREVIEW:
      'Actions Partner | Resources Admin Hide Preview',
    RESOURCES_ADMIN_DELETE: 'Actions Partner | Resources Admin Delete',
    RESOURCES_ADMIN_DELETES: 'Actions Partner | Resources Admin Deletes',
    RESOURCES_ADMIN_PINNED: 'Actions Partner | Resources Admin Pinned',
    RESOURCES_ADMIN_TOGGLE_STATE:
      'Actions Partner | Resources Admin Toggle State',
    RESOURCES_ADMIN_SELECT_ALL: 'Actions Partner | Resources Admin Select All',
    RESOURCES_ADMIN_EXPORT_CSV: 'Actions Partner | Resources Admin Export Csv',
    RESOURCES_ADMIN_EXPORT_PDF: 'Actions Partner | Resources Admin Export Pdf',
    RESOURCES_ADMIN_ADD_SCREEN: 'Actions Partner | Resources Admin Add Screen',
    RESOURCES_ADMIN_EDIT_SCREEN:
      'Actions Partner | Resources Admin Edit Screen',
    RESOURCES_ADMIN_OPEN_LINK: 'Actions Partner | Resources Admin Open Link',
    RESOURCES_ADMIN_OPEN_NOTES: 'Actions Partner | Resources Admin Open Notes',
    RESOURCES_ADMIN_HIDE_NOTES: 'Actions Partner | Resources Admin Hide Notes',
    RESOURCES_ADMIN_EXPORT_NOTES:
      'Actions Partner | Resources Admin Export Notes',
    RESOURCES_ADMIN_EDIT_SUBMIT:
      'Actions Partner | Resources Admin Edit Submit',
    RESOURCES_ADMIN_ADD_SUBMIT: 'Actions Partner | Resources Admin Add Submit',

    COGNITO_FORMS_ADMIN_SEARCH: 'Actions Partner | Cognito Forms Admin Search',
    COGNITO_FORMS_ADMIN_ADD_SCREEN:
      'Actions Partner | Cognito Forms Admin Add Screen',
    COGNITO_FORMS_ADMIN_EDIT_SCREEN:
      'Actions Partner | Cognito Forms Admin Edit Screen',
    COGNITO_FORMS_ADMIN_ADD_SUBMIT:
      'Actions Partner | Cognito Forms Admin Add Submit',
    COGNITO_FORMS_ADMIN_EDIT_SUBMIT:
      'Actions Partner | Cognito Forms Admin Edit Submit',
    COGNITO_FORMS_ADMIN_CHANGE_TAB:
      'Actions Partner | Cognito Forms Admin Change Tab',
    COGNITO_FORMS_TOGGLE_STATUS:
      'Actions Partner | Cognito Forms Admin Toggle Status',
    COGNITO_FORMS_ADMIN_DELETE: 'Actions Partner | Cognito Forms Admin Delete',
    COGNITO_FORMS_ADMIN_CLOSE_MODAL_FORM:
      'Actions Partner | Cognito Forms Admin Close Modal Form',

    LEARNINGS_ADMIN_CHANGE_VIEW:
      'Actions Partner | Learnings Admin Change View',
    LEARNINGS_ADMIN_CHANGE_TAB: 'Actions Partner | Learnings Admin Change Tab',
    LEARNINGS_ADMIN_ADD_MODULE: 'Actions Partner | Learnings Admin Add Module',
    LEARNINGS_ADMIN_REORDER_MODULE_SERIE:
      'Actions Partner | Learnings Admin Reorder Module Serie',
    LEARNINGS_ADMIN_DELETE_MODULE_SERIE:
      'Actions Partner | Learnings Admin Delete Module Serie',
    LEARNINGS_ADMIN_DELETES_MODULE_SERIES:
      'Actions Partner | Learnings Admin Deletes Module Series',
    LEARNINGS_ADMIN_TOGGLE_STATUS_MODULE_SERIE:
      'Actions Partner | Learnings Admin Toggle Status Module Serie',
    LEARNINGS_ADMIN_EDIT_MODULE_SERIE:
      'Actions Partner | Learnings Admin Edit Module Serie',
    LEARNINGS_ADMIN_SEARCH_MODULE_SERIE:
      'Actions Partner | Learnings Admin Search Module Serie',
    LEARNINGS_ADMIN_TOGGLE_SELECT_ALL_MODULE_SERIE:
      'Actions Partner | Learnings Admin Toggle Select All Module Serie',
    LEARNINGS_ADMIN_DELETE_MODULE:
      'Actions Partner | Learnings Admin Delete Module',
    LEARNINGS_ADMIN_TOGGLE_STATUS_MODULE:
      'Actions Partner | Learnings Admin Toggle Status Module',
    LEARNINGS_ADMIN_REORDER_MODULE:
      'Actions Partner | Learnings Admin Reorder Module',
    LEARNINGS_ADMIN_SEARCH_MODULE:
      'Actions Partner | Learnings Admin Search Module',
    LEARNINGS_ADMIN_TOGGLE_SELECT_ALL_MODULE:
      'Actions Partner | Learnings Admin Toggle Select All Module',
    LEARNINGS_ADMIN_DELETES_MODULES:
      'Actions Partner | Learnings Admin Deletes Modules',
    LEARNINGS_ADMIN_PREVIEW_MODULE:
      'Actions Partner | Learnings Admin Preview Module',
    LEARNINGS_ADMIN_OPEN_PREVIEW_MODULE:
      'Actions Partner | Learnings Admin Open Preview Module',
    LEARNINGS_ADMIN_CLOSE_PREVIEW_MODULE:
      'Actions Partner | Learnings Admin Close Preview Module',
    LEARNINGS_ADMIN_OPEN_PREVIEW:
      'Actions Partner | Learnings Admin Open Preview',
    LEARNINGS_ADMIN_CLOSE_PREVIEW:
      'Actions Partner | Learnings Admin Close Preview',
    LEARNINGS_ADMIN_PREVIEW_SEARCH:
      'Actions Partner | Learnings Admin Preview Search',
    LEARNINGS_ADMIN_ADD_SCREEN_MODULE:
      'Actions Partner | Learnings Admin Add Screen Module',
    LEARNINGS_ADMIN_EDIT_SCREEN_MODULE:
      'Actions Partner | Learnings Admin Edit Screen Module',
    LEARNINGS_ADMIN_ADD_SUBMIT_MODULE:
      'Actions Partner | Learnings Admin Add Submit Module',
    LEARNINGS_ADMIN_EDIT_SUBMIT_MODULE:
      'Actions Partner | Learnings Admin Edit Submit Module',
    LEARNINGS_ADMIN_ADD_SCREEN_MODULE_SERIE:
      'Actions Partner | Learnings Admin Add Screen Module Serie',
    LEARNINGS_ADMIN_EDIT_SCREEN_MODULE_SERIE:
      'Actions Partner | Learnings Admin Edit Screen Module Serie',
    LEARNINGS_ADMIN_ADD_SUBMIT_MODULE_SERIE:
      'Actions Partner | Learnings Admin Add Submit Module Serie',
    LEARNINGS_ADMIN_EDIT_SUBMIT_MODULE_SERIE:
      'Actions Partner | Learnings Admin Edit Submit Module Serie',
    LEARNINGS_ADMIN_NEXT_STEP_MODULE_SERIE:
      'Actions Partner | Learnings Admin Next Step Module Serie',
    LEARNINGS_ADMIN_PREV_STEP_MODULE_SERIE:
      'Actions Partner | Learnings Admin Prev Step Module Serie',
    LEARNINGS_ADMIN_ADD_MODULE_FROM_MODULE_SERIE:
      'Actions Partner | Learnings Admin Add Module From Module Serie',
    LEARNINGS_ADMIN_EDIT_MODULE_FROM_MODULE_SERIE:
      'Actions Partner | Learnings Admin Edit Module From Module Serie',
    LEARNINGS_ADMIN_DELETE_MODULE_FROM_MODULE_SERIE:
      'Actions Partner | Learnings Admin Delete Module From Module Serie',
    LEARNINGS_ADMIN_ADD_MODULE_CATEGORY:
      'Actions Partner | Learnings Admin Add Module Category',
    LEARNINGS_ADMIN_DELETE_MODULE_CATEGORY:
      'Actions Partner | Learnings Admin Delete Module Category',
    LEARNINGS_ADMIN_CHECKED_MODULE_CATEGORY:
      'Actions Partner | Learnings Admin Checked Module Category',
    CARE_GUIDES_ADMIN_SEARCH: 'Actions Partner | Care Guides Admin Search',
    CARE_GUIDES_ADMIN_RESET: 'Actions Partner | Care Guides Admin Reset',
    CARE_GUIDES_ADMIN_EDIT_SUBMIT:
      'Actions Partner | Care Guides Admin Edit Submit',
    CARE_GUIDES_ADMIN_EDIT_SCREEN:
      'Actions Partner | Care Guides Admin Edit Screen',
    DASHBOARD_ADMIN_REORDER_SECTIONS:
      'Actions Partner | Dashboard Admin Reorder Sections',
    DASHBOARD_ADMIN_TOGGLE_PINNED:
      'Actions Partner | Dashboard Admin Toggle Pinned',
    DASHBOARD_ADMIN_RESOURCE_OPEN_LINK:
      'Actions Partner | Dashboard Admin Resource Open Link',
    DASHBOARD_ADMIN_RESOURCE_OPEN_ADD_MODAL:
      'Actions Partner | Dashboard Admin Resource Open Add Modal',
    DASHBOARD_ADMIN_RESOURCE_ADD_MODAL_SEARCH_ADD_MODAL:
      'Actions Partner | Dashboard Admin Resource Add Modal Search',
    DASHBOARD_ADMIN_RESOURCE_CLOSE_ADD_MODAL:
      'Actions Partner | Dashboard Admin Resource Close Add Modal',
    DASHBOARD_ADMIN_RESOURCE_TOGGLE_PINNED_ADD_MODAL:
      'Actions Partner | Dashboard Admin Resource Toggle Pinned Add Modal',
    DASHBOARD_ADMIN_RESOURCE_PINNED_ADD_MODAL:
      'Actions Partner | Dashboard Admin Resource Pinned Add Modal',
    DASHBOARD_ADMIN_RESOURCE_SEARCH_ADD_MODAL:
      'Actions Partner | Dashboard Admin Resource Search Add Modal',
    DASHBOARD_ADMIN_RESOURCE_CHANGE_VIEW_ADD_MODAL:
      'Actions Partner | Dashboard Admin Resource Change View Add Modal',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_CHANGE_PAGE:
      'Actions Partner | Dashboard Admin Recommended Utilities Change Page',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_DOWNLOAD:
      'Actions Partner | Dashboard Admin Recommended Utilities Download',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_OPEN_WEBSITE:
      'Actions Partner | Dashboard Admin Recommended Utilities Open Website',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_DELETE:
      'Actions Partner | Dashboard Admin Recommended Utilities Delete',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_ADD_SCREEN:
      'Actions Partner | Dashboard Admin Recommended Utilities Add Screen',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_EDIT_SCREEN:
      'Actions Partner | Dashboard Admin Recommended Utilities Edit Screen',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_ADD_SUBMIT:
      'Actions Partner | Dashboard Admin Recommended Utilities Add Submit',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_EDIT_SUBMIT:
      'Actions Partner | Dashboard Admin Recommended Utilities Edit Submit',
    DASHBOARD_ADMIN_RECOMMENDED_UTILITIES_CLOSE_MODAL_FORM:
      'Actions Partner | Dashboard Admin Recommended Utilities Close Modal Form',
    MEMBERS_ADMIN_TOGGLE_SELECT_ALL:
      'Actions Partner | Members List Admin Toggle Select All',
    MEMBERS_ADMIN_SEARCH: 'Actions Partner | Members List Admin Search',
    MEMBERS_ADMIN_APPLY_FILTERS:
      'Actions Partner | Members List Admin Apply Filters',
    MEMBERS_ADMIN_OPEN_EVENT_FORM_MODAL:
      'Actions Partner | Members List Admin Open Event Form Modal',
    MEMBERS_ADMIN_OPEN_RESOURCE_FORM_MODAL:
      'Actions Partner | Members List Admin Open Resource Form Modal',
    MEMBERS_ADMIN_CLEAR_FILTERS:
      'Actions Partner | Members List Admin Clear Filters',
    MEMBERS_ADMIN_RESIZE_COLUMN:
      'Actions Partner | Members List Admin Resize Column',
    MEMBERS_ADMIN_REMOVE_FILTER:
      'Actions Partner | Members List Admin Remove Filter',
    MEMBERS_ADMIN_CLEAR_SELECTION:
      'Actions Partner | Members List Admin Clear Selection',
    MEMBERS_ADMIN_CREATE_EVENT_SUBMIT:
      'Actions Partner | Members List Admin Create Event Submit',
    MEMBERS_ADMIN_CREATE_RESOURCE_SUBMIT:
      'Actions Partner | Members List Admin Create Resource Submit',
    MEMBERS_ADMIN_CLOSE_EVENT_FORM_MODAL:
      'Actions Partner | Members List Admin Close Event Form Modal',
    MEMBERS_ADMIN_CLOSE_RESOURCE_FORM_MODAL:
      'Actions Partner | Members List Admin Close Resource Form Modal',
    MEMBERS_ADMIN_CLOSE_EXPORT_MODAL:
      'Actions Partner | Members List Admin Close Export Modal',
    MEMBERS_ADMIN_OPEN_EXPORT_MODAL:
      'Actions Partner | Members List Admin Open Export Modal',
    MEMBERS_ADMIN_EXPORT_PDF_SUBMIT:
      'Actions Partner | Members List Admin Export Pdf Submit',
    MEMBERS_ADMIN_NEXT_STEP_RESOURCE_FORM:
      'Actions Partner | Members List Admin Next Step Resource Form',
    MEMBERS_ADMIN_PREV_STEP_RESOURCE_FORM:
      'Actions Partner | Members List Admin Prev Step Resource Form',
    MEMBERS_ADMIN_DAILY_LOG_SUBMIT:
      'Actions Partner | Members List Admin Daily Log Submit',
    MEMBERS_ADMIN_DAILY_LOG_EDIT:
      'Actions Partner | Members List Admin Daily Log Edit',
    MEMBERS_ADMIN_DAILY_LOG_RESET:
      'Actions Partner | Members List Admin Daily Log Reset',
    MEMBERS_ADMIN_DAILY_LOG_DELETE:
      'Actions Partner | Members List Admin Daily Log Delete',
    MEMBERS_ADMIN_DAILY_LOG_EXPORT:
      'Actions Partner | Members List Admin Daily Log Export',
    MEMBERS_ADMIN_DAILY_LOG_FILTER:
      'Actions Partner | Members List Admin Daily Log Filter',
    MEMBERS_ADMIN_DAILY_LOG_COLLAPSE:
      'Actions Partner | Members List Admin Daily Log Collapse',
    MEMBERS_ADMIN_MEMBER_PROFILE_SUBMIT:
      'Actions Partner | Members List Admin Member Profile Submit',
    MEMBERS_ADMIN_NOTES_FILTER:
      'Actions Partner | Members List Admin Notes Filter',
    MEMBERS_ADMIN_NOTES_SEARCH:
      'Actions Partner | Members List Admin Notes Search',
    MEMBERS_ADMIN_NOTES_EXPORT_OPEN_MODAL:
      'Actions Partner | Members List Admin Notes Export Open Modal',
    MEMBERS_ADMIN_NOTES_EXPORT_CANCEL:
      'Actions Partner | Members List Admin Notes Export Cancel',
    MEMBERS_ADMIN_NOTES_EXPORT_PDF:
      'Actions Partner | Members List Admin Notes Export Pdf',
    MEMBERS_ADMIN_NOTES_OPEN_MODAL:
      'Actions Partner | Members List Admin Notes Open Modal',
    MEMBERS_ADMIN_NOTES_CLOSE_MODAL:
      'Actions Partner | Members List Admin Notes Close Modal',
    MEMBERS_ADMIN_NOTES_DELETE_NOTE:
      'Actions Partner | Members List Admin Notes Delete Note',
    MEMBERS_ADMIN_NOTES_NOTE_PINNED_TOGGLE:
      'Actions Partner | Members List Admin Notes Note Pinned Toggle',
    MEMBERS_ADMIN_NOTES_EDIT_NOTE_SUBMIT:
      'Actions Partner | Members List Admin Notes Edit Note Submit',
    MEMBERS_ADMIN_NOTES_CREATE_NOTE_SUBMIT:
      'Actions Partner | Members List Admin Notes Create Note Submit',
    MEMBERS_ADMIN_NOTES_SELECT_NOTE:
      'Actions Partner | Members List Admin Notes Select Note',
    MEMBERS_ADMIN_NOTES_PAGINATION:
      'Actions Partner | Members List Admin Notes Pagination',
    MEMBERS_ADMIN_DOCUMENTS_FILTER:
      'Actions Partner | Members List Admin Documents Filter',
    MEMBERS_ADMIN_DOCUMENTS_SEARCH:
      'Actions Partner | Members List Admin Documents Search',
    MEMBERS_ADMIN_DOCUMENTS_OPEN_MODAL:
      'Actions Partner | Members List Admin Documents Open Modal',
    MEMBERS_ADMIN_DOCUMENTS_CLOSE_MODAL:
      'Actions Partner | Members List Admin Documents Close Modal',
    MEMBERS_ADMIN_DOCUMENTS_DELETE_DOCUMENT:
      'Actions Partner | Members List Admin Documents Delete Document',
    MEMBERS_ADMIN_DOCUMENTS_EDIT_DOCUMENT_SUBMIT:
      'Actions Partner | Members List Admin Documents Edit Document Submit',
    MEMBERS_ADMIN_DOCUMENTS_CREATE_DOCUMENT_SUBMIT:
      'Actions Partner | Members List Admin Documents Create Document Submit',
    MEMBERS_ADMIN_DOCUMENTS_PAGINATION:
      'Actions Partner | Members List Admin Documents Pagination',
    MEMBERS_ADMIN_DOCUMENTS_EXPORT_OPEN_MODAL:
      'Actions Partner | Members List Admin Documents Export Open Modal',
    MEMBERS_ADMIN_DOCUMENTS_EXPORT_PDF:
      'Actions Partner | Members List Admin Documents Export Pdf',
    MEMBERS_ADMIN_DOCUMENTS_EXPORT_CANCEL:
      'Actions Partner | Members List Admin Documents Export Cancel',
    MEMBERS_ADMIN_DOCUMENTS_DELETE_DOCUMENT_SUBMIT:
      'Actions Partner | Members List Admin Documents Archive Document Submit',
    MEMBERS_ADMIN_DOCUMENTS_PINNED_TOGGLE:
      'Actions Partner | Members List Admin Documents Pinned Toggle',
    MEMBERS_ADMIN_DOCUMENTS_RESIZE:
      'Actions Partner | Members List Admin Documents Resize',
    MEMBERS_ADMIN_COGNITO_FORM_INTERNAL_FORMS_RESET:
      'Actions Partner | Members List Admin Cognito Form Internal Forms Reset',
    MEMBERS_ADMIN_COGNITO_FORM_INTERNAL_FORMS_EDIT:
      'Actions Partner | Members List Admin Cognito Form Internal Forms Edit',
    MEMBERS_ADMIN_COGNITO_FORM_INTERNAL_FORMS_DELETE_SUBMIT:
      'Actions Partner | Members List Admin Cognito Form Internal Forms Delete Submit',
    MEMBERS_ADMIN_COGNITO_FORM_INTERNAL_FORMS_SUBMIT:
      'Actions Partner | Members List Admin Cognito Form Internal Forms Submit',
    MEMBERS_ADMIN_COGNITO_FORM_INTERNAL_FORMS_FILTER:
      'Actions Partner | Members List Admin Cognito Form Internal Forms Filter',
    MEMBERS_ADMIN_COGNITO_FORM_INTERNAL_FORMS_COLLAPSE:
      'Actions Partner | Members List Admin Cognito Form Internal Forms Collapse',
    MEMBERS_ADMIN_COGNITO_FORM_INTERNAL_FORMS_EXPORT:
      'Actions Partner | Members List Admin Cognito Form Internal Forms Export',
  },
};

class Mixpanel {
  constructor() {
    Logger.log('debug', `Mixpanel.constructor()`);
    mixpanel.init(Config.get('MIXPANEL_TOKEN'), {
      debug: true,
      track_pageview: true,
      persistence: 'localStorage',
    });
  }

  track(eventName, props) {
    mixpanel.track(eventName, props);
  }
  identify(userId) {
    mixpanel.identify(userId);
  }
  setUserInfo(props) {
    mixpanel.people.set_once(props);
  }

  mixpanelTrack(eventDescription, customProps = {}) {
    const { authToken, userId } = Auth.getSession();
    const sessionId = authToken?.split('.')?.pop();
    this.identify(userId);
    this.track(eventDescription, {
      session_id: sessionId,
      ...customProps,
    });
  }
}

const MixpanelTracker = new Mixpanel();
export { MixpanelTracker, mixpanelEventsEnum };

Logger.log('silly', `Mixpanel loaded.`);
